import React from "react"

export const getTriangleSize = (pointSize) => (pointSize * 2) / Math.sqrt(2)

export const TrianglePointSVG = ({ pointSize, cx, cy, colour }) => {
  const SIZE_ROOT_2 = getTriangleSize(pointSize)
  return (
    <path
      d={`M${cx},${cy - SIZE_ROOT_2} L${cx - SIZE_ROOT_2},${cy + SIZE_ROOT_2} L${cx + SIZE_ROOT_2},${
        cy + SIZE_ROOT_2
      } Z`}
      stroke={colour}
      fill={colour}
    />
  )
}

export const CirclePointSVG = ({ pointSize, cx, cy, colour }) => {
  return <circle cx={cx} cy={cy} r={pointSize} fill={colour} stroke="none" />
}

export default function PointLayer({ data, getXValue, getYValue, colour, pointSize = 3, pointModifier }) {
  const fnColour = typeof colour === "function"

  return (
    <g>
      {data.map((obs, i) => {
        const cx = getXValue(obs)
        const cy = getYValue(obs)
        const obsColor = fnColour ? colour(obs) : colour
        if (pointModifier === "triangle") {
          return <TrianglePointSVG key={i} pointSize={pointSize} cx={cx} cy={cy} colour={obsColor} />
        } else {
          return <CirclePointSVG key={i} pointSize={pointSize} cx={cx} cy={cy} colour={obsColor} />
        }
      })}
    </g>
  )
}
